import { Row, Col, Typography } from 'antd';
import { GetUserResponse } from 'App/api/endpoints/users/responses';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface UserSecurityTabProps {
	user: GetUserResponse;
}

const UserSecurityTab = ({ user }: UserSecurityTabProps) => {
	const { t } = useTranslation(['page', 'form', 'common']);

	if (user) {
		return (
			<>
				<Row gutter={[16, 16]}>
					{user.lockoutEnabled && (
						<Col span={24}>
							<Typography>
								<Typography.Text type='secondary'>
									{t('models:User.Labels.LockedUntil')}:{' '}
								</Typography.Text>
								<Typography.Text>{user.lockoutEnd}</Typography.Text>
							</Typography>
						</Col>
					)}
					<Col span={24}>
						<Typography>
							<Typography.Text type='secondary'>
								{t('models:User.Labels.AccessFailedCount')}:{' '}
							</Typography.Text>
							<Typography.Text>{user.accessFailedCount}</Typography.Text>
						</Typography>
					</Col>
					<Col span={24}>
						<Typography>
							<Typography.Text type='secondary'>
								{t('models:User.Labels.TwoFactor')}:{' '}
							</Typography.Text>
							<Typography.Text>
								{user.twoFactorEnabled
									? t('AdminPages.UsersPages.Active')
									: t('AdminPages.UsersPages.Inactive')}
							</Typography.Text>
						</Typography>
					</Col>
				</Row>
			</>
		);
	} else {
		return <></>;
	}
};

export default UserSecurityTab;
